import { APIError } from '../../../services/api'

/**
 * Emit a stable, support-friendly console signal for a swallowed fetch in the Integrations drawer.
 *
 * Enough to pinpoint the failing call when a customer shares their console — area + operation + HTTP
 * status + the server's controlled detail (capped at 200 chars) — WITHOUT dumping the response body
 * (`APIError.data`), stack traces, request URLs/headers, or tokens. In prod a 5xx `detail` is just
 * "Internal Server Error", so there's no internals leak. Callers keep their graceful fallback
 * (empty list / default state); this only adds the diagnostic breadcrumb the silent catch was hiding.
 */
export function logIntegrationFetchError(area: string, operation: string, err: unknown): void {
  const status = err instanceof APIError ? err.status : undefined
  const reason = err instanceof Error ? err.message : ''
  console.error(
    `[integrations] ${area}: ${operation} failed`
    + (status ? ` (HTTP ${status})` : '')
    + (reason ? ` — ${reason.slice(0, 200)}` : ''),
  )
}

/** Proper-case CRM label for log/area tags from a provider slug. */
export function crmLabel(provider?: string): string {
  if (provider === 'hubspot') return 'HubSpot'
  if (provider === 'pipedrive') return 'Pipedrive'
  return 'Salesforce'
}
